import { render, staticRenderFns } from "./AgreeMannerFeedback.vue?vue&type=template&id=72149eca"
import script from "./AgreeMannerFeedback.vue?vue&type=script&lang=js"
export * from "./AgreeMannerFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports